export default __webpack_public_path__ + "src/images/packages/villa-one-hilltop/f4cf1b7d566c0e101059e59458698b96-3.jpg";